import React from 'react';
import { caracteristics } from '../../constants/images';
import styles from './carBrandCharacteristics.module.scss';

interface CarBrandCharacteristicsProps {
    vehicle?: any;
    publication?: any;
    selectedVersion?: string;
    className?: string;
}

const CarBrandCharacteristics: React.FC<CarBrandCharacteristicsProps> = ({
    vehicle,
    publication,
    selectedVersion,
    className
}) => {
    const selectedVehicle = selectedVersion && publication?.versions
        ? publication.versions.find((v: any) => v.id === selectedVersion) || publication?.versions[0]
        : vehicle;

    const carType = selectedVehicle?.type || publication?.type || '-';
    const fuel = selectedVehicle?.fuel || publication?.fuel || '-';
    const transmission = selectedVehicle?.transmission || publication?.transmission || '-';
    const doors = selectedVehicle?.doors || publication?.doors || '-';

    return (
        <div className={`${styles.mainCharacteristics} ${className || ''}`}>
            <div className={styles.characteristicItem}>
                <span className={styles.characteristicIcon}>
                    <img src={caracteristics.type} alt="Carrocería" />
                </span>
                <div className={styles.characteristicContent}>
                    <p className={styles.characteristicTitle}>Carrocería</p>
                    <p className={styles.characteristicValue}>{carType}</p>
                </div>
            </div>
            <div className={styles.characteristicItem}>
                <span className={styles.characteristicIcon}>
                    <img src={caracteristics.fuel} alt="Combustible" />
                </span>
                <div className={styles.characteristicContent}>
                    <p className={styles.characteristicTitle}>Combustible</p>
                    <p className={styles.characteristicValue}>  {fuel ? fuel.charAt(0).toUpperCase() + fuel.slice(1) : '-'}          </p>
                </div>
            </div>
            <div className={styles.characteristicItem}>
                <span className={styles.characteristicIcon}>
                    <img src={caracteristics.transmission} alt="Transmisión" />
                </span>
                <div className={styles.characteristicContent}>
                    <p className={styles.characteristicTitle}>Transmisión</p>
                    <p className={styles.characteristicValue}>{transmission}</p>
                </div>
            </div>
            <div className={styles.characteristicItem}>
                <span className={styles.characteristicIcon}>
                    <img src={caracteristics.door} alt="Puertas" />
                </span>
                <div className={styles.characteristicContent}>
                    <p className={styles.characteristicTitle}>Puertas</p>
                    <p className={styles.characteristicValue}>{doors}</p>
                </div>
            </div>
        </div>
    );
};

export default CarBrandCharacteristics;
